import { Table as TableKit } from 'appkit-react';

const Table = () => {
    const dataSource = [
        {
            Countries: 'United States',
            Region: 'North America',
            CountryScore: 50,
            CombinedScore: 95,
        },
    ];
    const columns = [
        {
            Header: 'Countries',
            accessor: 'Countries',
        },
        {
            Header: 'Region',
            accessor: 'Region',
        },
    ];
    return (
        <div className="table-demo a-apply-theme-background-gray-level-1">
            <TableKit
                data={dataSource}
                columns={columns}
                sortable
                size="lg"
                resizable
                defaultPageSize={5}
            />
        </div>
    );
};

export default Table;
